import { Control } from "react-hook-form";
import { SplitDatePickerFormField } from "../../../formfields/DatePickerFormField/SplitDatePickerFormField";
import { ToggleFormField } from "../../../formfields/ToggleFormField";
import { PersonsVirtualizedSelectForm } from "../../../forms/EntityForms/formsVirtualized/PersonsVirtualizedSelectForm";
import { SelectFormField } from "../../../formfields/SelectFormField";
import { SignatureTypes } from "../../../../api/Signature";
import { ISignableEntityForm } from "./SignableEntityFilterFormModels";
import { FoldableFilters } from "./common/FoldableFilters";
import { ILockableEntityForm } from "./LockableEntityFilterFormModels";

export const SignableEntityFilterForm = <FormValues extends ISignableEntityForm & ILockableEntityForm>({
  control,
  initialValues,
}: {
  control: Control<any, any, any>;
  initialValues?: FormValues;
}) => {
  const stateArray = [
    !!initialValues?.isSigned,
    !!initialValues?.signedByIds,
    !!initialValues?.notSignedByIds,
    !!initialValues?.signatureTypes,
    !!initialValues?.signedFrom,
    !!initialValues?.signedTo,
    !!initialValues?.lockedByIds,
    !!initialValues?.lockedFrom,
    !!initialValues?.lockedTo,
    !!initialValues?.isLocked,
  ];
  return (
    <FoldableFilters label="Locking / Signatures" defaultOpen={stateArray.some((p) => p) && !!stateArray.length}>
      <PersonsVirtualizedSelectForm
        id="lockedByIds"
        label="Locked by"
        control={control}
        isMulti
        filters={{ includeSystemUsers: true }}
      />

      <SplitDatePickerFormField
        control={control}
        idStart="lockedFrom"
        idEnd="lockedTo"
        label="Content locked (from - to)"
        horizontal={false}
        showTimeSelect
      />

      <ToggleFormField id="isLocked" control={control} label="Is locked" horizontal allowIntermediate />

      <PersonsVirtualizedSelectForm id="signedByIds" label="Signed by" control={control} isMulti />

      <PersonsVirtualizedSelectForm id="notSignedByIds" label="Not signed by" control={control} isMulti />

      <SelectFormField
        id="signatureTypes"
        label="Signature types"
        control={control}
        isMulti
        horizontal={false}
        items={SignatureTypes.filter((t) => t !== "Unknown").map((type) => ({ id: type, name: type }))}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
      />

      <SplitDatePickerFormField
        control={control}
        idStart="signedFrom"
        idEnd="signedTo"
        label="Content signed (from - to)"
        horizontal={false}
        showTimeSelect
      />

      <ToggleFormField id="isSigned" control={control} label="Is signed" horizontal allowIntermediate />
    </FoldableFilters>
  );
};
